// /src/pages/private/members/MembersOnboardingLayout.jsx

import React from 'react';
import { Outlet } from 'react-router-dom';
import PrivateRoute from '../../../PrivateRoute';

export default function MembersOnboardingLayout() {
  return (
    <PrivateRoute>
      <Outlet />
    </PrivateRoute>
  );
}
